import { Component, HostListener, inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-multi-formular-snack-bar',
    templateUrl: './multi-open-formular-snack-bar.component.html',
    styleUrl: './multi-open-formular-snack-bar.component.scss',
})
export class MultiFormularSnackBarComponent {
    private snackBarRef = inject(MatSnackBarRef);

    @HostListener('document:keydown.esc')
    cancleClick(): void {
        this.snackBarRef.dismiss();
    }
}
